import { Lock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  LIFECYCLE_STAGE_COLORS,
  LIFECYCLE_STAGE_LABELS,
  type LifecycleStage,
} from '@/constants/lifecycleStages';

interface Props {
  stage: LifecycleStage | null | undefined;
  isOverridden: boolean;
  className?: string;
}

export default function LifecycleStageBadge({ stage, isOverridden, className }: Props) {
  if (!stage) return <span className="text-muted-foreground">—</span>;
  return (
    <Badge
      variant="outline"
      className={cn(
        'inline-flex items-center gap-1 text-[10px] px-2 py-0.5 font-semibold rounded-md border',
        LIFECYCLE_STAGE_COLORS[stage],
        isOverridden && 'border-dashed',
        className,
      )}
    >
      {isOverridden && <Lock className="h-3 w-3" aria-label="Đã đè thủ công" />}
      {LIFECYCLE_STAGE_LABELS[stage]}
    </Badge>
  );
}
